import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class ShallowSeaMediumPiratesSalvageableTileEntity extends TileEntity {
	public static readonly frameName = FrameName.SHALLOW_SEA_MEDIUM_PIRATES;
}

export default ShallowSeaMediumPiratesSalvageableTileEntity;
